import { render, staticRenderFns } from "./OrderNumberStats.vue?vue&type=template&id=9115e21c&"
import script from "./OrderNumberStats.vue?vue&type=script&lang=js&"
export * from "./OrderNumberStats.vue?vue&type=script&lang=js&"
import style0 from "./OrderNumberStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrderNumberStats.vue"
export default component.exports